/**
 * Proposal colors are indexed from 0..length-1 (baseline UI uses {@link BASELINE_COLOR}, not slot 0).
 */
export const PROPOSAL_COLORS = [
  '#762F39',
  '#72B1A0',
  '#F3AE92',
  '#2A4764',
  '#EDA239',
  '#E9546C',
  '#C8ACB0',
];

export const BASELINE_COLOR = '#DDDDDD';
